import * as timex from "timex"

export const INFISO = timex.infinity().toISO()
export const NEGINFISO = timex.negInfinity().toISO()

export function getDaysArray(startDate: Date, endDate: Date): Date[] {
	const result: Date[] = []
	const d = new Date(startDate)
	d.setUTCHours(0, 0, 0, 0)
	const end = new Date(endDate)
	end.setUTCHours(0, 0, 0, 0)
	for (; d <= end; d.setUTCDate(d.getUTCDate() + 1)) {
		result.push(new Date(d))
	}
	return result
}

export function toDayKey(d: Date): string {
	return d.toISOString().slice(0, 10)
}

export function capitalize(s: string): string {
	return s.charAt(0).toUpperCase() + s.slice(1)
}

export function formatCategory(category: string): string {
	return category.split("_").map(capitalize).join(" ")
}
